// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.el-icon-arrow-right[data-v-b50ef614] {\n  color: #fff;\n}\n[data-v-b50ef614] .el-breadcrumb__separator {\n  display: none !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
